import { Controller, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FormRow from "components/FormRow";
import formRowStyles from "components/FormRow/FormRow.module.scss";
import { DefaultDatabase } from "components/LeftSidebar/UserModal/DefaultDatabase";
import { DefaultEngine } from "components/LeftSidebar/UserModal/DefaultEngine";
import RoleSelect from "components/RoleSelect/RoleSelect";
import { TextInput } from "components/TextInput/TextInput";

import { Fields } from "./schema";

type Props = {
  form: UseFormReturn<Fields>;
};
export const UserSection = (props: Props) => {
  const { form } = props;
  const { t } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
    watch,
  } = form;
  const accountName = watch("accountName");
  return (
    <>
      <FormRow
        required
        label={t("serviceAccounts.modal.user_name")}
        input={
          <TextInput
            testId="user-name-input"
            inputRootClassName={formRowStyles.nameInput}
            className={formRowStyles.nameInputContainer}
            {...register("userName")}
            error={!!errors?.userName}
            helperText={errors?.userName?.message}
            required
            autoComplete="off"
          />
        }
      />
      <FormRow
        label={t("serviceAccounts.modal.role")}
        input={
          <Controller
            control={control}
            name="roles"
            render={({ field: { onChange, value = [] } }) => (
              <RoleSelect
                value={value}
                onChange={onChange}
                accountName={accountName}
              />
            )}
          />
        }
      />
      <DefaultDatabase
        control={control}
        accountName={accountName}
      />
      <DefaultEngine
        control={control}
        accountName={accountName}
      />
    </>
  );
};
